import { DashboardType } from '@squaredup/dashboards';
import { fiveMinutes } from 'queries/constants';
import { dashboardQueryKeys } from 'queries/queryKeys/dashboardKeys';
import { useQuery, UseQueryOptions } from 'react-query';
import { Get } from 'services/DashboardService';
import { useDashboards } from './useDashboards';

type QueryReturnType = Awaited<ReturnType<typeof Get>>;
type QuerySelectReturnType = QueryReturnType | undefined;

/**
 * useQuery returning a specific dashboards. We populate the initialData using the useDashboards data (if it exists)
 * @param options The react-query options e.g. refreshInterval
 * @returns An array of all dashboards in a tenant
 */
export const useDashboard = (
    dashboardId?: string,
    options?: Omit<
        UseQueryOptions<QueryReturnType[], unknown, QuerySelectReturnType, string[]>,
        'enabled' | 'initialData' | 'select'
    >
) => {
    return useDashboards<DashboardType | undefined>({
        ...options,
        select(data) {
            return data.find(({ id }) => id === dashboardId);
        }
    });
};

/**
 * Use this hook only for OA dashboards when the standard useDashboard hook is blocked.
 */
export const useOADashboard = (dashboardId?: string) => {
    return useQuery(dashboardQueryKeys.detail(dashboardId), async () => Get(dashboardId!), {
        enabled: Boolean(dashboardId),
        staleTime: fiveMinutes,
        cacheTime: fiveMinutes
    });
};
